import { render, staticRenderFns } from "./queryTdx.vue?vue&type=template&id=27a08f1a&scoped=true&"
import script from "./queryTdx.vue?vue&type=script&lang=js&"
export * from "./queryTdx.vue?vue&type=script&lang=js&"
import style0 from "./queryTdx.vue?vue&type=style&index=0&id=27a08f1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a08f1a",
  null
  
)

export default component.exports